<template>
    <v-app>
        <v-container fluid>
            <template v-if="$insertAccess($route.path)">
                <v-form @submit.prevent="submit">
                    <v-row>
                        <v-col cols="12">
                            
                            <v-card :loading="employeeDataLoading">
                                <template #loader>
                                  <v-progress-linear
                                      color="blue-darken-3"
                                      height="3.5"
                                      v-if="employeeDataLoading"
                                      indeterminate
                                  />
                                </template>
                                <v-card-title class="text-subtitle-1 bg-blue-grey-lighten-4 mb-0 pa-1">
                                    <v-icon class="me-1" size="small">mdi-trending-up</v-icon>
                                    Employee Details
                                </v-card-title>

                                <v-card-text class="pa-2"> 
                                        
                                    <v-row class="ma-0">
                                        <v-col cols="6" class="pa-1">
                                            <v-autocomplete
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                :items="getHrmEmployeeList"
                                                :item-title="(item) => `${ item.code } - ${ item.name }`"
                                                item-value="id"
                                                v-model="employee_id.value.value"
                                                :error-messages="employee_id.errorMessage.value"
                                                :loading="employeesLoading"
                                                autocomplete="off"
                                                clearable
                                                hide-details="auto"
                                            
                                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                <template #label>
                                                    Employee
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>
                                        </v-col>

                                        <v-col lg="3" md="3" cols="12" class="pa-1">
                                            <v-text-field
                                            v-if="!isEntryMode"
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            autocomplete="off"
                                            clearable
                                            hide-details="auto"
                                            v-model="code.value.value"
                                            :disabled="!isEntryMode"
                                            :error-messages="code.errorMessage.value"
                                            >
                                                <template #label>
                                                    Code
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-text-field>
                                        </v-col>
                                    </v-row> 

                                    <v-expand-transition v-show="employeeData">
                                        <v-card disabled variant="outlined" class="ma-1 pa-3">
                                            <v-card-title class="text-subtitle-1 mb-0 pa-1">
                                                <v-icon class="me-1" size="small">mdi-account</v-icon>
                                                Employee Information    
                                            </v-card-title>
                                            
                                            <v-row class="pa-3">
                                                <v-col cols="12" md="6" class="pa-1">
                                                    <v-text-field
                                                        v-model="employeeName"
                                                        label="Name"
                                                        readonly
                                                        density="compact"
                                                        variant="outlined"
                                                        hide-details="auto"
                                                    />
                                                </v-col>

                                                <v-col cols="12" md="6" class="pa-1">
                                                    <v-text-field
                                                        v-model="employeeDepartment"
                                                        label="Department"
                                                        readonly
                                                        density="compact"
                                                        variant="outlined"
                                                        hide-details="auto"
                                                    />
                                                </v-col>

                                                <v-col cols="12" md="6" class="pa-1">
                                                    <v-text-field
                                                        v-model="employeeDesignation"
                                                        label="Designation"
                                                        readonly
                                                        density="compact"
                                                        variant="outlined"
                                                        hide-details="auto"
                                                    />
                                                </v-col>
                                                
                                                <v-col cols="12" md="6" class="pa-1">
                                                    <v-text-field
                                                        v-model="employeeJoiningDate"
                                                        label="Joining Date"
                                                        readonly
                                                        density="compact"
                                                        variant="outlined"
                                                        hide-details="auto"
                                                    />
                                                </v-col>
                                            </v-row>
                                        </v-card>
                                    </v-expand-transition>
                                </v-card-text>
                            </v-card>

                            <v-card class="mt-4">
                                <v-card-title class="text-subtitle-1 bg-blue-grey-lighten-4 mb-0 pa-1">
                                    <v-icon class="me-1" size="small">mdi-trending-up</v-icon>
                                    Increment
                                </v-card-title>

                                <v-card-text class="pa-2">   
                                    <v-row class="ma-0">
                                        <v-col lg="3" md="3" cols="12" class="pa-1">
                                            <v-autocomplete
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="increment_type.value.value"
                                                :error-messages="increment_type.errorMessage.value"
                                                :items="getIncrementTypes"
                                                :item-title="(item) => item.text"
                                                item-value="value"
                                                autocomplete="off"
                                                hide-details="auto"
                                                clearable
                                            
                                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                <template #label>
                                                    Increment Type
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>
                                        </v-col>

                                        <v-col lg="3" md="3" cols="12" class="pa-1">
                                            <v-date-input
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-calendar"
                                                v-model="increment_date.value.value"
                                                :error-messages="increment_date.errorMessage.value"
                                                autocomplete="off"
                                                hide-details="auto"
                                                input-format="dd/mm/yyyy"
                                                clearable
                                            >
                                                <template #label>
                                                Increment Date
                                                <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-date-input>
                                        </v-col>

                                        <v-col lg="3" md="3" cols="12" class="pa-1">
                                            <v-date-input
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-calendar"
                                                v-model="effect_date.value.value"
                                                :error-messages="effect_date.errorMessage.value"
                                                autocomplete="off"
                                                hide-details="auto"
                                                input-format="dd/mm/yyyy"
                                                clearable
                                            >
                                                <template #label>
                                                    Effect Date
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-date-input>
                                        </v-col>

                                        <v-col lg="3" md="3" cols="12" class="pa-1">
                                            <v-text-field
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            autocomplete="off"
                                            type="number"
                                            clearable
                                            hide-details="auto"
                                            v-model.number="increment_amount.value.value"
                                            :error-messages="increment_amount.errorMessage.value"
                                            >
                                                <template #label>
                                                    Increment Amount
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-text-field>
                                        </v-col>
                                    </v-row> 
                                    
                                    <v-expand-transition v-show="increment_type.value.value==='promotion'">
                                        <v-row class="ma-0">
                                            <v-col cols="3" class="pa-1">
                                                <v-autocomplete
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4"
                                                    :items="getHrmDesignationList"
                                                    :item-title="(item) => item.name"
                                                    item-value="id"
                                                    v-model="new_designation_id.value.value"
                                                    :error-messages="new_designation_id.errorMessage.value"
                                                    :loading="designationLoading"
                                                    autocomplete="off"
                                                    clearable
                                                    hide-details="auto"
                                                
                                                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                    <template #label>
                                                        New Designation
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-autocomplete>
                                            </v-col>

                                            <v-col cols="3" class="pa-1">
                                                <v-autocomplete
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4"
                                                    :items="getHrmDepartmentList"
                                                    :item-title="(item) => item.name"
                                                    item-value="id"
                                                    v-model="new_department_id.value.value"
                                                    :error-messages="new_department_id.errorMessage.value"
                                                    :loading="departmentLoading"
                                                    autocomplete="off"
                                                    clearable
                                                    hide-details="auto"
                                                
                                                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                    <template #label>
                                                        New Department
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-autocomplete>
                                            </v-col>
                                        </v-row> 
                                    </v-expand-transition>
                                    
                                </v-card-text>
                            </v-card>

                            <v-row class="mt-2">

                                <v-col lg="6" md="6" cols="12">
                                    <v-card :loading="employeeDataLoading" disabled>
                                        <template #loader>
                                          <v-progress-linear
                                              color="blue-darken-3"
                                              height="3.5"
                                              v-if="employeeDataLoading"
                                              indeterminate
                                          />
                                        </template>
                                        <v-card-title class="text-subtitle-1 bg-blue-grey-lighten-4 mb-0 pa-1">
                                            <v-icon class="me-1" size="small">mdi-currency-usd</v-icon>
                                            Before Increment (Salary Information)
                                        </v-card-title>

                                        <v-checkbox
                                        label="Gross Distribution Status"
                                        v-model="before_gross_distribution_status.value.value"
                                        density="compact"
                                        variant="outlined"
                                        hide-details
                                        single-line
                                        class="px-2"
                                        readonly
                                        color="primary"
                                        :true-value="true"
                                        :false-value="false"
                                        ></v-checkbox>

                                        <v-row class="px-3 pt-5">

                                            <v-col cols="6" class="py-0">
                                                <v-text-field
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4"
                                                    v-model="before_gross.value.value"
                                                    label="Gross Salary"
                                                    type="number"
                                                    readonly
                                                />
                                            </v-col>

                                            <v-col cols="6" class="py-0">
                                                <v-text-field
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4"
                                                    v-model="before_basic.value.value"
                                                    label="Basic"
                                                    type="number"
                                                    readonly
                                                />
                                            </v-col>

                                            <v-col cols="6" class="py-0">
                                                <v-text-field
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4"
                                                    v-model="before_house_rent.value.value"
                                                    label="House Rent"
                                                    type="number"
                                                    readonly
                                                />
                                            </v-col>

                                            <v-col cols="6" class="py-0">
                                                <v-text-field
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4"
                                                    v-model="before_medical.value.value"
                                                    label="Medical"
                                                    type="number"
                                                    readonly
                                                />
                                            </v-col>

                                            <v-col cols="6" class="py-0">
                                                <v-text-field
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4"
                                                    v-model="before_conveyance.value.value"
                                                    label="Conveyance"
                                                    type="number"
                                                    readonly
                                                />
                                            </v-col>

                                            <v-col cols="6" class="py-0">
                                                <v-text-field
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4"
                                                    v-model="before_others.value.value"
                                                    label="Others"
                                                    type="number"
                                                    readonly
                                                />
                                            </v-col>

                                        </v-row>
                                    </v-card>
                                </v-col>

                                
                                <v-col lg="6" md="6" cols="12">
                                    <v-card>
                                        <v-card-title class="text-subtitle-1 bg-blue-grey-lighten-4 mb-0 pa-1">
                                            <v-icon class="me-1" size="small">mdi-trending-up</v-icon>
                                            After Increment (Salary Information)
                                        </v-card-title>

                                        <v-checkbox
                                        label="Gross Distribution Status"
                                        v-model="after_gross_distribution_status.value.value"
                                        density="compact"
                                        variant="outlined"
                                        hide-details
                                        single-line
                                        class="px-2"
                                        color="primary"
                                        :true-value="true"
                                        :false-value="false"
                                        ></v-checkbox>

                                        <v-row class="px-3 pt-5">
                                            <v-col cols="6" class="py-0">
                                                <v-text-field
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4"
                                                    label="Gross Salary"
                                                    type="number"
                                                    v-model="after_gross.value.value"
                                                    :disabled="!distributionDisable"
                                                    readonly
                                                />
                                            </v-col>

                                            <v-col cols="6" class="py-0">
                                                <v-text-field
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4"
                                                    label="Basic"
                                                    type="number"
                                                    v-model="after_basic.value.value"
                                                    :disabled="distributionDisable"
                                                    readonly
                                                />
                                            </v-col>

                                            <v-col cols="6" class="py-0">
                                                <v-text-field
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4"
                                                    label="House Rent"
                                                    type="number"
                                                    v-model="after_house_rent.value.value"
                                                    :disabled="distributionDisable"
                                                    readonly
                                                    />
                                            </v-col>

                                            <v-col cols="6" class="py-0">
                                                <v-text-field
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4"
                                                    label="Medical"
                                                    type="number"
                                                    v-model="after_medical.value.value"
                                                    :disabled="distributionDisable"
                                                    readonly
                                                />
                                            </v-col>

                                            <v-col cols="6" class="py-0">
                                                <v-text-field
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4"
                                                    label="Conveyance"
                                                    type="number"
                                                    v-model="after_conveyance.value.value"
                                                    :disabled="distributionDisable"
                                                    readonly
                                                />
                                            </v-col>
                                            
                                            <v-col cols="6" class="py-0">
                                                <v-text-field
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4"
                                                    label="Others"
                                                    type="number"
                                                    v-model="after_others.value.value"
                                                />
                                            </v-col>
                                        </v-row>

                                    </v-card>
                                </v-col>
                            </v-row>

                            <v-card class="mt-2">
                                <v-card-actions>
                                    <v-row class="pt-2">
                                        <v-col cols="8">
                                            <v-textarea
                                            label="Remarks"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="remarks.value.value"
                                            :error-messages="remarks.errorMessage.value"
                                            autocomplete="off"
                                            rows="3"
                                            clearable
                                            ></v-textarea>
                                        </v-col>
                                        
                                        <v-col cols="4">
                                            <v-layout class="justify-end">
                                            <v-btn
                                                class="bg-grey-darken-1 me-2"
                                                variant="flat"
                                                @click="submitForm(0)"
                                                >DRAFT</v-btn
                                            >
                                            <v-btn
                                                class="bg-primary"
                                                variant="flat"
                                                @click="submitForm(1)"
                                                >POST</v-btn
                                            >
                                            </v-layout>
                                        </v-col>
                                    </v-row>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-form>
            </template>
        </v-container>
    </v-app>
</template>

<script>

import {useStore} from 'vuex';
import { useField, useForm } from 'vee-validate';
import * as yup from 'yup';
import { ref } from 'vue';
import { toast } from 'vue3-toastify';
import { useRouter } from 'vue-router'; 
import { fileServerUrl } from "@/store/api";
import formattedDate from '@/plugins/dateFormatter';

export default {
    components: {},
    data: () => ({
        itemsPerPage:10,
        isEntryMode: true,
        panel: [0],
        search: "",
        employeeData: null,

        employeeEmpID: null,
        employeeName: null,
        employeeDepartment: null,
        employeeDesignation: null,
        employeeJoiningDate: null,
        employeeMobile: null,
        employeeEmail: null,
        employeeType: null,

        incrementAmount: 0,

        employeeDataLoading: false,
        employeesLoading: false,
        designationLoading: false,
        departmentLoading: false,
        salaryDistributionLoading: false,
    }),

    watch: {
        "employee_id.value.value": {
            handler(val) {
                if (val) {
                    this.employeeDataLoading = "blue-darken-3";
                    this.$store.dispatch("getEmployeeDetails", val)
                        .then((res) => {
                            this.employeeData = res.data.data;

                            const data = res.data.data;
                            const salaryData = data?.salary_info?.[0];

                            this.employeeEmpID = data.code;
                            this.employeeName = data.name;
                            this.employeeDepartment = data?.department?.name;
                            this.employeeDesignation = data?.designation?.name;
                            this.employeeJoiningDate = data.joining_date;
                            this.employeeMobile = data.mobile;
                            this.employeeEmail = data.email;
                            this.employeeType = data?.employee_type?.name;

                            this.before_gross_distribution_status.value.value = salaryData?.gross_distribution_status;
                            this.before_basic.value.value = salaryData?.basic_salary;
                            this.before_gross.value.value = salaryData?.gross_salary;
                            this.before_house_rent.value.value = salaryData?.house_rent;
                            this.before_medical.value.value = salaryData?.medical;
                            this.before_conveyance.value.value = salaryData?.conveyance;
                            this.before_others.value.value = salaryData?.others;

                            this.after_gross_distribution_status.value.value = this.isEntryMode
                                ? salaryData?.gross_distribution_status 
                                : this.after_gross_distribution_status.value.value;
                                
                            this.after_basic.value.value = !this.isEntryMode && !this.after_gross_distribution_status.value.value
                                ? Number(salaryData?.basic_salary) + Number(this.incrementAmount)
                                : salaryData?.basic_salary;

                            this.after_gross.value.value = !this.isEntryMode && this.after_gross_distribution_status.value.value
                                ? Number(salaryData?.gross_salary) + Number(this.incrementAmount)
                                : salaryData?.gross_salary;
                                
                            this.after_house_rent.value.value = salaryData?.house_rent;
                            this.after_medical.value.value = salaryData?.medical;
                            this.after_conveyance.value.value = salaryData?.conveyance;
                            this.after_others.value.value = salaryData?.others;

                            this.employeeDataLoading = false;
                        })
                        .then(() => {
                            this.employeeDataLoading = false;
                        })
                } else {
                    this.employeeData = null;
                    this.employeeEmpID = null;
                    this.employeeName = null;
                    this.employeeDepartment = null;
                    this.employeeDesignation = null;
                    this.employeeJoiningDate = null;
                    this.employeeMobile = null;
                    this.employeeEmail = null;
                    this.employeeType = null;

                    this.before_gross_distribution_status.value.value = false;
                    this.before_basic.value.value = 0;
                    this.before_gross.value.value = 0;
                    this.before_house_rent.value.value = 0;
                    this.before_medical.value.value = 0;
                    this.before_conveyance.value.value = 0;
                    this.before_others.value.value = 0;

                    this.after_gross_distribution_status.value.value = false;
                    this.after_basic.value.value = 0;
                    this.after_gross.value.value = 0;
                    this.after_house_rent.value.value = 0;
                    this.after_medical.value.value = 0;
                    this.after_conveyance.value.value = 0;
                    this.after_others.value.value = 0;
                }
            }
        },

        "after_gross_distribution_status.value.value": {
            handler(val) {
                if (val) {
                    this.distributionDisable = true;
                    this.after_gross.value.value = Number(this.before_gross.value.value) + Number(this.increment_amount.value.value);
                    // this.after_basic.value.value = this.before_basic.value.value;
                    
                    const distro = this.getSalaryDistribution;
                    if (!distro) return;
                    const gross = this.after_gross.value.value;

                    this.after_basic.value.value = gross * distro.basic/100;
                    this.after_house_rent.value.value = gross * distro.houserent/100;
                    this.after_medical.value.value = gross * distro.medical/100;
                    this.after_conveyance.value.value = gross * distro.conveyance/100;

                } else {
                    this.distributionDisable = false;
                    this.after_gross.value.value = this.calculatedAfterGross;
                    this.after_basic.value.value = Number(this.before_basic.value.value) + Number(this.increment_amount.value.value);
                    this.after_house_rent.value.value = this.before_house_rent.value.value;
                    this.after_medical.value.value = this.before_medical.value.value;
                    this.after_conveyance.value.value = this.before_conveyance.value.value;
                }
            }
        },

        "increment_amount.value.value": {
            handler(newVal, oldVal) {
                //console.log(newVal)
                if(this.after_gross_distribution_status.value.value) {
                    if(newVal>0) {
                        this.after_gross.value.value = Number(this.after_gross.value.value || 0)  - Number(oldVal || 0);
                        this.after_gross.value.value = Number(this.after_gross.value.value ||0) + Number(newVal ||0);
                    }else {
                        this.after_gross.value.value = this.before_gross.value.value;
                    }
                } else {
                    if(newVal>0) {
                        this.after_basic.value.value = Number(this.after_basic.value.value || 0)  - Number(oldVal || 0);
                        this.after_basic.value.value = Number(this.after_basic.value.value ||0) + Number(newVal ||0);
                    }else {
                        this.after_basic.value.value = this.before_basic.value.value;
                        this.after_house_rent.value.value = this.before_house_rent.value.value;
                        this.after_medical.value.value = this.before_medical.value.value;
                        this.after_conveyance.value.value = this.before_conveyance.value.value;
                    }
                }
            }
        },

        calculatedAfterGross(val) {
            if (!this.after_gross_distribution_status.value.value) {
                this.after_gross.value.value = val;
            }
        },

        "after_gross.value.value": {
            handler(val) {
                if (this.after_gross_distribution_status.value.value && val > 0) {
                    const distro = this.getSalaryDistribution;
                    if (!distro) return;
                    const gross = this.after_gross.value.value;

                    this.after_basic.value.value = gross * distro.basic/100;
                    this.after_house_rent.value.value = gross * distro.houserent/100;
                    this.after_medical.value.value = gross * distro.medical/100;
                    this.after_conveyance.value.value = gross * distro.conveyance/100;
                    return;
                }
            }
        },

    },
    created() {
        // if (this.$store.getters.getHrmEmployeeList.length === 0) {
            this.employeesLoading = "blue-darken-3";
            this.$store.dispatch("getHrmEmployeeList")
            .then(() => {
                this.employeesLoading = false;
            });
        // }

        // if (this.$store.getters.getHrmDesignationList.length === 0) {
            this.designationLoading = "blue-darken-3";
            this.$store.dispatch("getHrmDesignationList")
            .then(() => {
                this.designationLoading = false;
            });
        // }
        // if (this.$store.getters.getHrmDepartmentList.length === 0) {
            this.departmentLoading = "blue-darken-3";
            this.$store.dispatch("getHrmDepartmentList")
            .then(() => {
                this.departmentLoading = false;
            });
        // }
        if (!this.$store.getters.getHrmEmployeeSalaryDistribution) {
            this.salaryDistributionLoading = "blue-darken-3";
            this.$store.dispatch("getHrmEmployeeSalaryDistribution")
            .then(() => {
                this.salaryDistributionLoading = false;
            })
        }
    },
    computed: {
        getHrmEmployeeList() {
            return this.$store.getters.getHrmEmployeeList;
        },
        getHrmDesignationList() {
            return this.$store.getters.getHrmDesignationList;
        },
        getHrmDepartmentList() {
            return this.$store.getters.getHrmDepartmentList;
        },
        getSalaryDistribution() {
            return this.$store.getters.getHrmEmployeeSalaryDistribution;
        },
        getIncrementTypes() {
            const data =[
                { text: 'Normal', value: 'normal' },
                { text: 'Performance', value: 'performance' },
                { text: 'Promotion', value: 'promotion' },
                { text: 'Special', value: 'special' }
            ]
            return data;
        },
        calculatedAfterGross() {
            return (
                Number(this.after_basic.value.value || 0) +
                Number(this.after_house_rent.value.value || 0) +
                Number(this.after_medical.value.value || 0) +
                Number(this.after_conveyance.value.value || 0) +
                Number(this.after_others.value.value || 0)
            );
        }
    },

    methods: {
        formattedDate,
    },

    setup() {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                employee_id: yup.string().required().label("Employee"),
                increment_type: yup.string().required().label("Increment type"),
                increment_date: yup.string().required().label("Increment date"),
                effect_date: yup.string().required().label("Effect date"),
                increment_amount: yup.number().required().label("Increment amount"),
                new_designation_id: yup
                    .string()
                    .nullable()
                    .when("increment_type", {
                        is: "promotion",
                        then: (schema) =>
                            schema.required("New designation is required"),
                        otherwise: (schema) => schema.nullable(),
                    }),

                new_department_id: yup
                    .string()
                    .nullable()
                    .when("increment_type", {
                        is: "promotion",
                        then: (schema) =>
                            schema.required("New department is required"),
                        otherwise: (schema) => schema.nullable(),
                    }),
            }),
        });

        const increment_id = useField("increment_id");
        const employee_id = useField("employee_id");

        const new_designation_id = useField("new_designation_id");
        const new_department_id = useField("new_department_id");
        const code = useField("code");

        const increment_amount = useField("increment_amount");
        const increment_type = useField("increment_type");
        const increment_date = useField("increment_date");
        const effect_date = useField("effect_date");
        
        const before_gross_distribution_status = useField("before_gross_distribution_status");
        const before_gross = useField("before_gross");
        const before_basic = useField("before_basic");
        const before_house_rent = useField("before_house_rent");
        const before_medical = useField("before_medical");
        const before_conveyance = useField("before_conveyance");
        const before_others = useField("before_others");

        const after_gross_distribution_status = useField("after_gross_distribution_status");
        const after_gross = useField("after_gross");
        const after_basic = useField("after_basic");
        const after_house_rent = useField("after_house_rent");
        const after_medical = useField("after_medical");
        const after_conveyance = useField("after_conveyance");
        const after_others = useField("after_others");

        const remarks = useField('remarks');
        const status = useField('status');
        
        const errorMessages  = ref('');

        const store = useStore();
        const router = useRouter();

        const currentStatus = ref(1);

        const submitForm = (status) => {
            currentStatus.value = status;
            submit();
        };

        const submit = handleSubmit((values) => { 

            const data = {
                v2:1,
                increment_id: values.increment_id,
                employee_id: values.employee_id,
                increment_type: values.increment_type ,
                new_department_id: values.new_department_id,
                increment_date: formattedDate(values.increment_date),
                effect_date: formattedDate(values.effect_date),
                new_designation_id: values.new_designation_id,
                code: values.code,
                remarks: values.remarks,
                status: currentStatus.value,
                increment_amount: values.increment_amount,
                after_salary: {
                    gross_distribution_status: values.after_gross_distribution_status,
                    gross_salary: values.after_gross,
                    basic: values.after_basic,
                    house_rent: values.after_house_rent,
                    medical: values.after_medical,
                    conveyance: values.after_conveyance,
                    others: values.after_others
                },
                before_salary: {
                    gross_distribution_status: values.before_gross_distribution_status,
                    gross_salary: values.before_gross,
                    basic: values.before_basic,
                    house_rent: values.before_house_rent,
                    medical: values.before_medical,
                    conveyance: values.before_conveyance,
                    others: values.before_others
                }
            }

            store.dispatch("saveOrUpdateIncrement", data) 
                .then((response) => {  
                    resetForm();
                    toast.success(response.message, {
                        timeout: 3000,
                    });
                    store.dispatch("getIncrementList")
                    setTimeout(() => {  
                        router.push({ path: "increment-list-v2" });
                    }, 2000);
                })
                .catch((error) => { 
                    console.error(error)   
                })
        })
        return {
            submit,
            submitForm,

            increment_id,
            employee_id,
            new_designation_id,
            new_department_id,
            code,

            increment_amount,
            increment_type,
            increment_date,
            effect_date,

            before_gross_distribution_status,
            before_gross,
            before_basic,
            before_house_rent,
            before_medical,
            before_conveyance,
            before_others,

            after_gross_distribution_status,
            after_gross,
            after_basic,
            after_house_rent,
            after_medical,
            after_conveyance,
            after_others,

            remarks,
            status,
            errorMessages,
            resetForm,
        }
    },
    mounted() {
        const id = this.$route.query.id;
        
        if(id) {
            this.isEntryMode = false;
            this.$store.dispatch("getIncrementById", id)
            .then(res=> {
                const incrementData = res.data;

                this.increment_id.value.value = id;
                this.employee_id.value.value = incrementData.employee_id;
                this.new_designation_id.value.value = incrementData.new_designation_id;
                this.new_department_id.value.value = incrementData.new_department_id;
                this.code.value.value = incrementData.code
                this.increment_amount.value.value = incrementData.increment_amount;
                this.incrementAmount = this.increment_amount.value.value;
                this.increment_type.value.value = incrementData.increment_type;
                this.increment_date.value.value = incrementData.increment_date;
                this.effect_date.value.value = incrementData.effect_date;

                this.before_gross_distribution_status.value.value = incrementData.before_gross_distribution_status === 1 ? true: false;
                this.after_gross_distribution_status.value.value = incrementData.after_gross_distribution_status === 1? true: false;
                this.remarks.value.value = incrementData.remarks
                
            })
        } else {
            this.code.value.value = null;
            this.new_designation_id.value.value = null;
            this.new_department_id.value.value = null;
            this.increment_type.value.value = "normal";
    
            this.before_gross_distribution_status.value.value = false;
            this.before_gross.value.value = 0;
            this.before_basic.value.value = 0;
            this.before_house_rent.value.value = 0;
            this.before_medical.value.value = 0;
            this.before_conveyance.value.value = 0;
            this.before_others.value.value = 0;
    
            this.after_gross_distribution_status.value.value = false
            this.increment_amount.value.value = 0
            this.after_gross.value.value = 0
            this.after_basic.value.value = 0
            this.after_house_rent.value.value = 0
            this.after_medical.value.value = 0
            this.after_conveyance.value.value = 0
            this.after_others.value.value = 0
            this.remarks.value.value = null
        }

    },
    beforeUnmount() {
        
    }
}
</script>

<style scoped>
.v-card-title {
    height: 40px;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 500;
}
</style>